<template>
  <div ref="captchaContainer"></div>
</template>

<script setup>
import { ref, onMounted, defineExpose } from 'vue'

const props = defineProps({
  siteKey: { type: String, required: true },
})

const captchaContainer = ref(null)
const token = ref('')

defineExpose({
  getToken: () => token.value,
  reset: () => {
    token.value = ''
    if (captchaContainer.value) {
      captchaContainer.value.innerHTML = ''
    }
    renderCaptcha()
  },
})

function renderCaptcha() {
  if (!window.smartCaptcha || !captchaContainer.value) {
    return
  }

  captchaContainer.value.innerHTML = ''

  window.smartCaptcha.render(captchaContainer.value, {
    sitekey: props.siteKey,
    callback: (t) => {
      token.value = t
    },
    'error-callback': () => (token.value = ''),
    'expired-callback': () => (token.value = ''),
  })
}

onMounted(() => {
  if (!window.smartCaptcha) {
    const script = document.createElement('script')
    script.src = 'https://smartcaptcha.yandexcloud.net/captcha.js?render=onload&onload=onloadFunction'
    script.async = true
    script.defer = true
    script.onload = renderCaptcha
    document.head.appendChild(script)
  } else {
    setTimeout(renderCaptcha, 0)
  }
})
</script>
